import signupImg from "../assets/Images/signup.webp"
import Template from "../Components/core/Auth/Template"
import { useSelector } from "react-redux";

function Signup() {
  const {loading} = useSelector((state)=>state.auth);
  return (
    loading ? (
    <div className="flex min-h-[calc(100vh-4rem)] items-center justify-center bg-richblack-900">
      <div className="custom-loader" />
    </div>
  ) : (
    <Template
      title="Start learning for free with StudyNotion"
      description1="Build skills for today, tomorrow, and beyond."
      description2="Education to future-proof your career."
      image={signupImg}
      formType="signup"
    />
  )
  );
}

export default Signup